export default __webpack_public_path__ + "static/media/1985.ecfd577c.png";